/**
 * Where a product's wholesale price actually lives (KP-3861).
 *
 * `retailPrice` is a field on the product. Wholesale is not: it lives on each
 * item, and the catalog aggregation exposes the spread as `minPrice`/`maxPrice`
 * ($min/$max of items.price). A product-level `price` only appears once the
 * authenticated pricing pass has decorated it from the caller's wallet rule and
 * price book — and a public link has no entity, so no wallet rule, so no
 * decoration. Reading `price` alone means a public link can never show WSP,
 * whatever the brand chose.
 *
 * Returns the lowest of the item prices when the decorated value is missing.
 * That matches how RRP already behaves on these cards — one figure per product,
 * per-item variation not shown — rather than introducing a range on one row and
 * not the other.
 *
 * Both wishlist pages render public links, so both use this.
 */
export function wholesalePriceOf(productInfo) {
  const info = productInfo || {}

  if (typeof info.discountedPrice === 'number') return info.discountedPrice
  if (typeof info.price === 'number') return info.price
  if (typeof info.minPrice === 'number') return info.minPrice

  return null
}

/** The undiscounted figure, for the struck-through original next to a discount. */
export function listWholesalePriceOf(productInfo) {
  const info = productInfo || {}

  if (typeof info.price === 'number') return info.price
  if (typeof info.minPrice === 'number') return info.minPrice

  return null
}

export function hasWholesalePriceFor(productInfo) {
  return wholesalePriceOf(productInfo) !== null
}
